import { useCallback } from "react";
import { getFileExtension } from "@entrilia/shared/utilities/fileHelper";
import adminApi from "../../../../../api/adminApi";
import DocumentPreview from "../../../../common/document-preview/DocumentPreview";
import WorkflowFilePreviewHeader from "./WorkflowFilePreviewHeader";

interface Props {
  workflowId: string;
  fileName: string;
  fileCatalogId: string;
  onClose: () => void;
}

const WorkflowDocumentPreview = ({ workflowId, fileName, fileCatalogId, onClose }: Props) => {
  const getFileDownloadInfo = useCallback(
    () => adminApi.getWorkflowDocumentFileDownloadInfo(workflowId, fileCatalogId),
    [workflowId, fileCatalogId]
  );

  return (
    <>
      <WorkflowFilePreviewHeader title={fileName} fileExtension={getFileExtension(fileName)} onClose={onClose} />
      <DocumentPreview getFileDownloadInfoCallback={getFileDownloadInfo} />
    </>
  );
};

export default WorkflowDocumentPreview;
